import { SetPasswordFormValues } from './types';

export const setPasswordDataKeys: { [K in keyof SetPasswordFormValues]: K } = {
    password: 'password',
    confirmPassword: 'confirmPassword',
};

export const setPasswordDataDefaultValues = {
    email: '',
    password: '',
};
